import { schema, types } from 'papr'

export const teamPublicationRoleInviteSchema = schema(
	{
		publication: types.objectId({ required: true }),
		createdBy: types.objectId({ required: true }),
		role: types.enum(['contributor' as const, 'admin' as const], {
			required: true,
		}),
		/**
		 * Is false when revoked
		 */
		isActive: types.boolean({ required: true }),
		/**
		 * Capacity of how many members to be invited by the link, it is configurable by the admins
		 */
		capacity: types.number(),
		/**
		 * If true, then capacity is unlimited. This has higher priority than the `capacity` field.
		 */
		isUnlimitedCapacity: types.boolean({ required: true }),
		/**
		 * Number of members who have joined the publication by the link.
		 * Used capacity will always be checked before a new member joins the publication by the invite.
		 */
		usedCapacity: types.number({ required: true }),
		inviteToken: types.string({ required: true }),
		expiryDate: types.date(),
		createdAt: types.date({ required: true }),
	},
	{
		timestamps: true,
		defaults: {
			isActive: true,
			isUnlimitedCapacity: false,
			usedCapacity: 0,
		},
	},
)

export type TeamPublicationRoleInviteDocument = (typeof teamPublicationRoleInviteSchema)[0]
export type teamPublicationRoleInviteDefaults = (typeof teamPublicationRoleInviteSchema)[1]
